function mainSlider() {
	const mainBlock = document.querySelectorAll(".js-main-slider");

	mainBlock.forEach((element) => {
		const swiperEl = element.querySelector(".swiper");

		const mainSwiper = new Swiper(swiperEl, {
			loop: true,
			speed: 1000,
			touchEventsTarget: swiperEl.wrapperEl,
			// autoplay: {
			// 	delay: 2500,
			// 	disableOnInteraction: false,
			// },
			navigation: {
				nextEl: element.querySelector(".swiper-button-next"),
				prevEl: element.querySelector(".swiper-button-prev"),
			},
			pagination: {
				el: element.querySelector(".swiper-pagination"),
				type: "bullets",
			},
			breakpoints: {
				320: {
					slidesPerView: 1.2,
					spaceBetween: 16,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
			},
		});
	});
}

function podcastSlider() {
	const podcastBlock = document.querySelectorAll(".js-podcast-slider");

	podcastBlock.forEach((element) => {
		const swiperEl = element.querySelector(".swiper");

		const podcastSwiper = new Swiper(swiperEl, {
			loop: true,
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 16,
			touchEventsTarget: swiperEl.wrapperEl,
			// autoplay: {
			// 	delay: 2500,
			// 	disableOnInteraction: false,
			// },
			navigation: {
				nextEl: element.querySelector(".swiper-button-next"),
				prevEl: element.querySelector(".swiper-button-prev"),
			},
			pagination: {
				el: element.querySelector(".swiper-pagination"),
				type: "bullets",
			},
		});
	});
}

function slidersInit() {
	mainSlider();
	podcastSlider();
}

export default slidersInit;
